import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { BodyImageI } from '../../../interfaces/body/body-img.interface';
import { UserI } from '../../../interfaces/users/user.interface';
import { BodyImgService } from '../../../services/body-img.service';
import { MessageService } from '../../../services/message.service';
import {DateConv} from '../../../helpers/date-conv';

@Component({
  selector: 'app-user-body-list',
  templateUrl: './user-body-list.component.html',
  styleUrls: ['./user-body-list.component.scss']
})
export class UserBodyListComponent implements OnInit {

  // region Atributos
  @Input() userBodies: BodyImageI[];
  @Input() user: UserI;
  @Output() submit = new EventEmitter();
  public dateConv = DateConv;

  public bodyFormArray: FormArray;

  searchKey: string;
  listBodies: MatTableDataSource<any>;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  listOfColumns: string[] = ['imagen', 'comentarios'];
  public spinner = false;

  // endregion

  // region Constructor
  constructor(
    public messageService: MessageService,
    public fb: FormBuilder,
    public bodyServ: BodyImgService
  ) {
  }

  // endregion

  // region Métodos
  ngOnInit() {
    this.initBodyForm();

    for (let i = 0; i < this.userBodies.length; i++) {
      this.userBodies[i].imgURL = (this.userBodies[i].img) ? `${environment.filestorage}/body_images/${this.userBodies[i].img}` : 'assets/img/body-default.png';

      this.bodyFormArray.push(this.fillBodyForm(this.userBodies[i].id, this.userBodies[i]));
    }

    this.listBodies = new MatTableDataSource(this.userBodies);

    this.listBodies.sort = this.sort;
    this.listBodies.paginator = this.paginator;
  }

  initBodyForm() {
    this.bodyFormArray = this.fb.array([]);
  }

  fillBodyForm(body_id, bodyData: BodyImageI) {
    return this.fb.group({
      id: [(bodyData && bodyData.id) ? bodyData.id: 0],
      comment: [(bodyData && bodyData.comment) ? bodyData.comment : null]
    });
  }

  // Función para borrar el filtro de busqueda
  onSearchClear() {
    this.searchKey = '';
    this.applyFilter();
  }

  // Función para aplicar el filtro de busqueda
  applyFilter() {
    this.listBodies.filter = this.searchKey.trim().toLocaleLowerCase();
  }

  saveComment(bodyForm) {
    if (bodyForm.invalid) {
      this.messageService.printStatus('Debe llenar los campos marcados en rojo', 'warning');
      bodyForm.markAllAsTouched();
      return;
    }

    this.messageService.confirmRequest('¿Estás seguro de guardar esta información?').then((data) => {
      if (data.value) {
        this.bodyServ.saveComment(bodyForm['controls']['id'].value, bodyForm.value).subscribe(res => {
          if (res.ok === true) {
            this.messageService.printStatus(res.message, 'success');
            this.submit.emit(true);
          }
        }, error => {
          console.log(error);
          this.messageService.printStatusArray(error.error.errors, 'error');
        });
      }
    });
  }

  // endregion

}
